class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    mainpriceupdate();
    mob_mainpriceupdate();
    
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
      mainpriceupdate();
      mob_mainpriceupdate();
    }, 500);


    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    
    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
    mainpriceupdate();
    mob_mainpriceupdate();
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }    
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => { 
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false; 
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    if(document.querySelector('toggle-component price-range [name="filter.v.price.gte"]') && document.querySelector('toggle-component price-range [name="filter.v.price.lte"]')){
      var current_mini = document.querySelector('toggle-component price-range [name="filter.v.price.gte"]').value;
      var current_max = document.querySelector('toggle-component price-range [name="filter.v.price.lte"]').value;
      var current_rangePrice = document.querySelectorAll("#FacetsWrapperDesktop .facets__price input");
      if(current_mini != '' && current_max != ''){
      document.querySelector('.range-selected').style.left = (parseFloat(current_mini).toFixed(2) / current_rangePrice[1].max) * 100 + "%";
      document.querySelector('.range-selected').style.right = 100 - (parseFloat(current_max).toFixed(2) / current_rangePrice[1].max) * 100 + "%";
      document.querySelector('.range-input .min').value = current_mini;
      document.querySelector('.range-input .max').value = current_max;
      }
      if(current_mini != ''){
        document.querySelector('.range #min_sel_val').innerHTML = current_mini;
      }
      if(current_max != ''){
        document.querySelector('.range #max_sel_val').innerHTML = current_max;
      }
    }

    if(document.querySelector('.mobile-facets__main__content price-range [name="filter.v.price.gte"]') && document.querySelector('.mobile-facets__main__content price-range [name="filter.v.price.lte"]')){
      var mob_current_mini = document.querySelector('.mobile-facets__main__content price-range [name="filter.v.price.gte"]').value;
      var mob_current_max = document.querySelector('.mobile-facets__main__content price-range [name="filter.v.price.lte"]').value;
      var mob_current_rangePrice = document.querySelectorAll(".facets__price-container-mobile .facets__price__item input");
      if(mob_current_mini != '' && mob_current_max != ''){
      document.querySelector('.mob_range-selected').style.left = (parseFloat(mob_current_mini).toFixed(2) / mob_current_rangePrice[1].max) * 100 + "%";
      document.querySelector('.mob_range-selected').style.right = 100 - (parseFloat(mob_current_max).toFixed(2) / mob_current_rangePrice[1].max) * 100 + "%";
      document.querySelector('.mob_range-input .mob_min').value = mob_current_mini;
      document.querySelector('.mob_range-input .mob_max').value = mob_current_max;
      }
      if(mob_current_mini != ''){
        document.querySelector('.mob_range #mob_min_sel_val').innerHTML = mob_current_mini;
      }
      if(mob_current_max != ''){
        document.querySelector('.mob_range #mob_max_sel_val').innerHTML = mob_current_max;
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    FacetFiltersForm.renderPage(new URL(event.currentTarget.href).searchParams.toString());
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (minInput && maxInput) {
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 45);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
    }
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);




document.addEventListener("DOMContentLoaded", function() {
  var activeFacetsDesktop = document.querySelector('.active-facets-desktop');

  function updateVisibility() {
    // Controlla se ci sono elementi facet-remove che non sono active-facets__button-wrapper
    var hasFacets = Array.from(activeFacetsDesktop.children).some(child => 
      !child.classList.contains('active-facets__button-wrapper')
    );

    // Aggiungi o rimuovi la classe hide-element basandoti sulla presenza di altri facet-remove
    if (hasFacets) {
      activeFacetsDesktop.classList.remove('hide-element');
    } else {
      activeFacetsDesktop.classList.add('hide-element');
    }
  }

  // Crea un observer per monitorare i cambiamenti nel DOM
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        updateVisibility();
      }
    });
  });

  // Configura l'observer per monitorare l'aggiunta o rimozione di figli
  var config = { childList: true };
  observer.observe(activeFacetsDesktop, config);

  // Aggiorna la visibilità iniziale
  updateVisibility();
});

